document.addEventListener("DOMContentLoaded", function () {
  let menuItems = document.querySelectorAll(".header-menu-item-parent-sections--24520781037910__ss_header_10_xDCybH");

  menuItems.forEach(menuItem => {
    let dropdown = menuItem.querySelector(".header-submenu-sections--24520781037910__ss_header_10_xDCybH");
    let menuLink = menuItem.querySelector(".header-menu-link-sections--24520781037910__ss_header_10_xDCybH");

    if (dropdown) {
      // Öffne das Submenu, wenn über "Shop" gehovt wird
      menuItem.addEventListener("mouseenter", function () {
        dropdown.classList.add("open");
      });

      // Schließe das Submenu, wenn der Benutzer das Menü verlässt (außerhalb klicken)
      menuItem.addEventListener("mouseleave", function () {
        setTimeout(function () {
          if (!dropdown.matches(':hover') && !menuItem.matches(':hover')) {
            dropdown.classList.remove("open");
          }
        }, 200);
      });

      // Öffne das Submenu, wenn auf "Shop" geklickt wird
      menuLink.addEventListener("click", function (event) {
        event.preventDefault(); // Verhindert das Standardverhalten des Links
        dropdown.classList.toggle("open");
      });

      // Schließe das Submenu, wenn außerhalb des Submenus geklickt wird
      document.addEventListener("click", function (event) {
        // Überprüfen, ob der Klick außerhalb des Submenus und des Hauptmenüpunkts war
        if (!menuItem.contains(event.target) && !dropdown.contains(event.target)) {
          dropdown.classList.remove("open");
        }
      });

      // Verhindere das Schließen des Submenus, wenn im Dropdown selbst geklickt wird
      dropdown.addEventListener("click", function (event) {
        event.stopPropagation();  // Verhindert, dass der Klick nach außen weitergeleitet wird
      });
    }
  });
});

